import { toggleArrayElement } from 'utils/object';
import { ActionTypes, QuestionWithChoiceActionTypes } from './types';
import { QuestionsState } from '../types';

export default function reducer(state: QuestionsState, action: QuestionWithChoiceActionTypes) {
  const questionState: any = state;

  switch (action.type) {
    case ActionTypes.QUESTION_WITH_CHOICE_TOGGLE_ANSWER_IS_SELECTED:
      return toggleArrayElement(questionState, action.payload.answerId);
    case ActionTypes.QUESTION_WITH_CHOICE_SET_SINGLE_ANSWER_SELECTED:
    case ActionTypes.SET_SINGLE_ANSWER_SELECTED:
      questionState.splice(0, questionState.length, action.payload.answerId);
      return state;
    default:
      return state;
  }
}
